import NotFound from 'pages/error/404'
import { isRouteErrorResponse, useRouteError } from 'react-router'
import React, { useEffect } from 'react'

import Footer from 'components/molecules/Footer'
import Header from 'components/molecules/Header'
import { ErrorPageIcon } from 'assets'
import SmartLink from 'components/atoms/SmartLink'

export default function ErrorBoundary() {
  const error = useRouteError()

  //debuging purposes
  if (error instanceof Error) {
    console.log('error message', error.message)
    console.log('error stack', error.stack)
  }

  // Jika errornya adalah 404 router
  if (isRouteErrorResponse(error)) {
    return <NotFound />
  }

  // Jika error JS biasa
  if (error instanceof Error) {
    return (
      <div className="min-h-screen md:h-screen relative flex-col flex justify-between">
        <Header />
        <div className={'wrapper-title flex flex-col gap-[4px] items-center my-10'}>
          <div>
            <ErrorPageIcon />
          </div>
          <p className={'text-2xl font-bold text-primary text-left sm:text-center'}>
            Ups! Ada kesalahan teknis
          </p>
          <p className={'text-xl font-normal text-primary text-center'}>
            Kami sedang memperbaikinya. Silakan periksa kembali nanti.
          </p>

          <SmartLink
            isNextUrl={true}
            href={'/'}
            className="pt-10 text-primary hover:text-secondary no-underline">
            Back to main page
          </SmartLink>
        </div>
        <Footer />
      </div>
    )
  } else {
    return <h1>Error tidak diketahui</h1>
  }
}
